import { Icon, Spinner } from '@toggle/design-system';
import React from 'react';

import * as S from './UnreadConversation.styles';

interface UnreadConversationProps {
  status: string | null | undefined;
  question?: string;
  conversationName: string;
}

export const UnreadConversation = ({
  status,
  question,
  conversationName,
}: UnreadConversationProps) => {
  const renderStatusIcon = (status: string | null | undefined) => {
    switch (status) {
      case 'Processing':
        return <Spinner size="extraSmall" useAccentColor />;
      case 'Error':
        return (
          <Icon
            iconName="ExclamationCircle"
            size={12}
            fillColor="var(--icon-critical)"
          />
        );

      case 'Done':
        return (
          <Icon
            iconName="CheckmarkCircle"
            size={12}
            fillColor="var(--icon-success)"
          />
        );
      default:
        return (
          <Icon
            iconName="CheckmarkCircle"
            size={12}
            fillColor="var(--icon-success)"
          />
        );
    }
  };

  return (
    <S.ItemWrapper>
      <S.IconWrapper>{renderStatusIcon(status)}</S.IconWrapper>
      <S.StyledText $isProcessing={status === 'Processing'}>
        {question || conversationName}
      </S.StyledText>
    </S.ItemWrapper>
  );
};
